import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Clearance } from "../../../interfaces/clearance";
import { StudentRequirement } from "../../../interfaces/document-requirement";
import { RegistrationSetting } from "../../../interfaces/registration-setting";

@Injectable({
  providedIn: 'root'
})
export class ComplianceService {
  api: string = `${environment.api}/student`;

  constructor(private http: HttpClient) {
  }

  public clearances() {
    return this.http.get<Clearance[]>(`${this.api}/clearances`, { observe: "body" });
  }

  public requirements() {
    return this.http.get<StudentRequirement[]>(`${this.api}/requirements`, { observe: "body" });
  }
}
